const CARDINALS = ['N', 'NE', 'E', 'SE', 'S', 'SW', 'W', 'NW'] as const;

/**
 * Formats a compass heading for display (e.g. `NE 42°`).
 * Shared by the field-note viewer and PDF/image export metadata.
 */
export function formatCompassHeading(degrees: number | null | undefined): string | undefined {
  if (degrees == null || !Number.isFinite(degrees)) {
    return undefined;
  }
  const normalizedHeading = ((Math.round(degrees) % 360) + 360) % 360;
  const cardinal = CARDINALS[Math.round(normalizedHeading / 45) % 8];
  return `${cardinal} ${normalizedHeading}°`;
}
